import { useEffect } from 'react';
import FakturaDashboard from '../faktura/FakturaDashboard';

export default function LandingPageAuftraggeber() {

    useEffect(() => {
    }, []);

    return (
        <>
            <FakturaDashboard />
        </>
    );
}
